import React, { useState, useEffect } from "react";
import "../../components/AddCountry/AddCountry.css";

const AddCountry = () => {
  return (
    <div className="container-fluid">
      <br />

      <div className="countryDetail">
        <form className="country-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Country Name*</td>
              <td>Country Code</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addCountry-button">
          <button  type="submit"   style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add Country
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddCountry;
